import { FC, useMemo } from "react";
import StarRateNewTrustScore from "../../../components/StarRate2.0";
import { scoreToDisplayStars } from "../../../config/rating";
import { IWidgetTemplate } from "../../../interfaces/widget-template";
import { ReachClick } from "../../../utils/core";
import { resolveWidgetV2Style } from "./widgetV2Styles";

const LOGO_MARK = `${process.env.PUBLIC_URL}/images/logos/logo-mark.webp`;

/**
 * Floating Tab (v2) — admin-preview-only (shown inline here, not fixed to
 * the viewport, since this preview is rendered inside our own admin
 * iframe). The real embed (widget-v2.js, renderTab) uses position:fixed so
 * it anchors to the host page's viewport edge regardless of where the div
 * sits in the DOM.
 */
const WidgetTemplate28: FC<IWidgetTemplate> = ({ company, score, style }) => {
  const companyId = company?.companyId;
  const resolvedStyle = resolveWidgetV2Style("tab", style);
  const expanded = resolvedStyle === "expanded-panel";
  const radius = resolvedStyle === "left-edge" ? "0 8px 8px 0" : "8px 0 0 8px";
  const payload = useMemo(() => ({ companyId, widgetId: 28 as const }), [companyId]);
  const profileUrl = useMemo(
    () => `https://www.trustfinance.com/companies/${companyId}?utm_source=widget&utm_medium=dom&utm_campaign=widget-v2-tab`,
    [companyId],
  );

  return (
    <div className="d-flex justify-content-center">
      <a
        href={profileUrl}
        target="_blank"
        rel="noopener"
        onClick={() => ReachClick(payload)}
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: expanded ? 8 : 0,
          background: "#006bf1",
          color: "#fff",
          borderRadius: radius,
          padding: expanded ? "10px 14px" : "10px 6px",
          fontSize: expanded ? 12 : 9.5,
          fontWeight: 700,
          textDecoration: "none",
        }}
      >
        {expanded ? (
          <>
            <img src={LOGO_MARK} alt="" width={14} height={14} />
            <StarRateNewTrustScore value={score?.score} size={13} />
            <span>TrustScore {score?.score} · {(score?.totalReview ?? 0).toLocaleString()} reviews</span>
          </>
        ) : (
          <span style={{ writingMode: "vertical-rl" }}>★ {scoreToDisplayStars(score?.score ?? 0)} Reviews</span>
        )}
      </a>
    </div>
  );
};

export default WidgetTemplate28;
